<template>
  <div ref="sdm" class="gs-expansion-mask">
    <div ref="sdh" class="gs-expansion-holder">
      <NumericField type="graph" :obj="obj" limit="min"/>
      <NumericField type="graph" :obj="obj" limit="max"/>
      <div class="draw-markers">
        <div class="draw-markers-text">DRAW<br>MARKERS</div>
        <div class="dm-checkbox" @click.stop="">
          <input type="checkbox" class="gs-checkbox" v-model="this.markers"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NumericField from '@/components/nelson/NumericField';
import { useSettingsStore } from '@/store/SettingsStore';

export default {
  name: 'GraphSettingsExpansion',
  components: {
    NumericField,
  },
  mounted () {
    this.toggle();
  },
  props: [
    'obj',
  ],
  computed: {
    markers: {
      get () {
        return useSettingsStore().getGraphSettingMarkersOfType(this.$props.obj.value);
      },
      set (value) {
        useSettingsStore().setGraphSettingMarkersOfType(this.$props.obj.value, value);
      }
    }
  },
  methods: {
    toggle () {
      this.$refs.sdm.style.width = !useSettingsStore().getGraphSettingExpanded(this.$props.obj.value) ? 0 : '380px';
    }
  }
};
</script>

<style scoped>
.gs-expansion-mask {
  height: 55px;
  width: 0;
  overflow: hidden;

}
.gs-expansion-holder {
  height: 55px;
  display: flex;
  background-color: #f7f7f7;
  border-top: .5px solid #dedede;
  align-items: center;
  justify-content: space-between;
}
.gs-expansion-holder:hover {
  background-color: #f2f2f2;
}
.draw-markers {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-left: 2px;
  margin-right: 10px;
}
.draw-markers-text {
  font-size: 65%;
  font-weight: 700;
  text-align: center;
  line-height: .9em;
}
.dm-checkbox {
  cursor: pointer;
}
.gs-checkbox {
  cursor: pointer;
}
</style>